/* eslint-disable @nx/enforce-module-boundaries */

import { SearchIcon, CloseIcon } from '@chakra-ui/icons';
import {
  Box,
  Button,
  Checkbox,
  HStack,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  Text,
  VStack,
} from '@chakra-ui/react';
import { BackArrow, BackArrowRTL, MyNetworkNewIcon } from '@mybridge/icons';

import { Avatar, Spinner } from '@mybridge/ui';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getConnectionsData } from 'v4/store/actions/connection.actions';
import {
  CreateRoom,
  UpdateRoom,
  UpdateRoomInvited,
  UpdateRoomName,
  getSelectedRoomMembers,
} from 'v4/store/actions/global.data.actions';
import ChangeGroupName from '../change-group-name';
import { MatrixContext } from 'packages/mybridgev4/context/chat-context';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';
import { ANALYTICS_EVENTS, trackEvent } from 'v4/utils/analyticsEvents';

const ChatGroup = ({
  isGroupModalOpen,
  setIsGroupModalOpen,
  connectionList,
  onSelectChat,
  networkConnection, 
  setNetworkConnection,
  setRoomId,
  fetchRoomList,
  isCreateGroupedClicked,
  setIsCreateGroupedClicked,
  selectedChat,
  groupMemberDetail,
  roomId,
  isgroupNameModal,
  setIsgroupNameModal,
  setGroupName,
  groupName,
  socketRef,
  setGroupMemberDetail,
}) => {
  const {
    newChatDisc,
  } = useContext(MatrixContext);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const [groupNameOptional, setGroupNameOptional] = useState(null);
  const [createGroupLoading, setCreateGroupLoading] = useState(false);
  const direction = useDirection();
  // const [networkConnection, setNetworkConnection] = useState([]);
  const dispatch = useDispatch();
  const { t } = useTranslator();
  const { userProfileInfo } = useSelector((state) => state?.userProfile);

  /*
  useEffect(() => {
    dispatch(getConnectionsData()).then((res) => {
      setNetworkConnection(res?.payload?.results);
    });
  }, [connectionList]);
  */
  useEffect(() => {
    if (!isGroupModalOpen?.open) return;
    dispatch(getConnectionsData()).then((res) => {
      setNetworkConnection(res?.payload?.results);
    });
  }, [isGroupModalOpen?.open, connectionList]);

  const handleUpdateGroupName = () => {
    dispatch(
      UpdateRoomName({
        room_name: groupName,
        room_id: roomId,
      })
    ).unwrap()
    .then((res) => {
      // Emit socket event for group name update
      // socketRef?.current?.emit('chat_accepted', {
      //   room_id: roomId,
      //   user_id: userProfileInfo?.matrix_user_id,
      //   room_name: groupName
      // });
      // socketRef?.current?.emit('chat_avatar_updated', {
      //   room_id: roomId,
      //   user_id: userProfileInfo?.matrix_user_id,
      //   room_name: groupName
      // });
      // setRoomId();
      onSelectChat(res?.room);
    })
    .catch((error) => {
      setRoomId();
      console.error(error, 'error');
    })
    .finally(() => {
      setSelectedUserIds([]);
      setSelectedUsers([]);
      setIsgroupNameModal({ open: false, data: '' });
      setIsGroupModalOpen({ open: false, data: '' });
      // setTimeout(()=>{fetchRoomList()}, 5000)
      fetchRoomList()
    });
  };

  // useEffect(() => {
  //   if (socketRef?.current) {
  //       const handleUpdate = () => {
  //           fetchRoomList();
  //       };

  //       socketRef.current.on('chat_accepted', handleUpdate);
  //       socketRef.current.on('chat_avatar_updated', handleUpdate);

  //       return () => {
  //           socketRef.current.off('chat_accepted', handleUpdate);
  //           socketRef.current.off('chat_avatar_updated', handleUpdate);
  //       };
  //   }
  // }, [socketRef?.current]);

  const handleUpdateGroupUser = () => {
    dispatch(
      UpdateRoomInvited({
        room_id: roomId,
        invited_users: selectedUserIds,
      })
    )
      .then((res) => {
        // setRoomId();
        dispatch(getSelectedRoomMembers(roomId)).then((memberRes) => {
          if (memberRes?.payload?.members) {
            setGroupMemberDetail?.(memberRes.payload.members);
          }
        });
      })
      .catch((error) => {
        // setRoomId();
        console.error(error, 'error');
      })
      .finally(() => {
        setSelectedUserIds([]);
        setCreateGroupLoading(false);
        setSelectedUsers([]);
        // setRoomId();
        setIsgroupNameModal({ open: false, data: '' });
        setIsGroupModalOpen({ open: false, data: '' });
        fetchRoomList();
      });
  };

  const handleCreateGroup = () => {
    setCreateGroupLoading(true);
    const maxStringLength = 15;
  
    // Extract `first_name` from selected users
    let namesArray = selectedUsers?.map((item) => item?.first_name);
  
    let firstNameString = '';
  
    if (namesArray?.length === 1) {
      // If only one user is selected, include the user's first name and userProfileInfo's first name
      firstNameString = `${namesArray[0]}, ${userProfileInfo?.first_name}`;
    } else {
      // Otherwise, concatenate names and ensure the result fits the max length
      for (let i = 0; i < namesArray?.length; i++) {
        const tempString = firstNameString
          ? `${firstNameString}, ${namesArray[i]}`
          : namesArray[i];
        if (tempString?.length > maxStringLength) break;
        firstNameString = tempString;
      }
    }
  
    if (roomId && isGroupModalOpen?.data !== 'create') {
      handleUpdateGroupUser();
    } else {
      dispatch(
        CreateRoom({
          name: groupNameOptional?.length>0?groupNameOptional:firstNameString,
          room_type: "group",
          invited_users: selectedUserIds,
        })
      )
        .unwrap()
        .then(async (res) => {
          // Emit socket events with timestamp
          const socketPayload = {
            room_id: res?.room_id,
            user_id: userProfileInfo?.id,
            room_name: groupNameOptional?.length>0 ? groupNameOptional : firstNameString,
            timestamp: Date.now()
          };
    
          // socketRef?.current?.emit('chat_accepted', socketPayload);
          // socketRef?.current?.emit('chat_avatar_updated', socketPayload);
          
          // Wait for socket events to complete
          // await new Promise(resolve => setTimeout(resolve, 1500));
          // await fetchRoomList();
      // dispatch(
      //   CreateRoom({
      //     room_name: groupNameOptional?.length>0?groupNameOptional:firstNameString,
      //     invited_users: selectedUserIds,
      //   })
      // )
      //   .unwrap()
      //   .then((res) => {
      //     console.log('res');
      //   })
      //   .catch((error) => {
      //     console.error(error, 'error');
        })
        .then(()=>{
          trackEvent(ANALYTICS_EVENTS.CreateGroupChat, userProfileInfo?.slug || 'anonymous');
        })
        .finally(() => {
          setCreateGroupLoading(false)
          setSelectedUserIds([]);
          setSelectedUsers([]);
          setRoomId();
          setIsgroupNameModal({ open: false, data: '' });
          setIsGroupModalOpen({ open: false, data: '' });
          fetchRoomList();
          newChatDisc.onClose();
        });
    }
  };

  useEffect(() => {
    const handleGroupUpdate = async (data) => {
      if (data?.room_id && data?.timestamp) {
        // Add a small delay to ensure server processing is complete
        await new Promise(resolve => setTimeout(resolve, 300));
        await fetchRoomList();
      }
    };
  
    // if (socketRef?.current) {
    //   socketRef.current.on('chat_accepted', handleGroupUpdate);
    //   socketRef.current.on('chat_avatar_updated', handleGroupUpdate);
    // }
  
    return () => {
      // if (socketRef?.current) {
      //   socketRef.current.off('chat_accepted', handleGroupUpdate);
      //   socketRef.current.off('chat_avatar_updated', handleGroupUpdate);
      // }
    };
  }, [socketRef?.current, fetchRoomList]);
  

  const handleCheckboxChange = (user) => {
    setSelectedUsers((prevSelected) =>
      prevSelected?.some(
        (selectedUser) => selectedUser?.id === user?.id
      )
        ? prevSelected?.filter(
            (selectedUser) =>
              selectedUser?.id !== user?.id
          )
        : [...prevSelected, user]
    );
    setSelectedUserIds((prevSelectedIds) =>
      prevSelectedIds.includes(user.id)
        ? prevSelectedIds.filter((id) => id !== user.id)
        : [...prevSelectedIds, user.id]
    );
  };
  
  // const filteredConnectionList = networkConnection?.filter((user) =>
  //   user?.first_name?.toLowerCase().includes(searchTerm.toLowerCase())
  // );
  // const filteredConnectionList = networkConnection?.filter((user) =>
  //   user?.first_name?.toLowerCase().includes(searchTerm.toLowerCase()) &&
  //   !groupMemberDetail?.some(member => member.id === user.id)
  // );

  const filteredConnectionList = networkConnection?.filter((user) => {
    const matchesSearch = user?.first_name
      ?.toLowerCase()
      .includes(searchTerm.toLowerCase());

    if (isGroupModalOpen?.data === 'edit') {
      return (
        matchesSearch &&
        !groupMemberDetail?.some((member) => member.id === user.id)
      );
    }

    return matchesSearch;
  });

  const handleRemoveSelectedUser = (id) => {
    const updatedUsers = selectedUsers.filter(
      (user) => user.id !== id
    );
    setSelectedUsers(updatedUsers);
  };

  useEffect(() => {
    if (selectedChat || groupMemberDetail?.length > 0) {
      const value =
        groupMemberDetail?.length > 0
          ? filteredConnectionList?.filter((item) =>
              groupMemberDetail.some((member) => member?.id === item?.id)
            )
          : filteredConnectionList?.filter(
              (item) =>
                item?.id === selectedChat?.user_details?.user_id
            );

      // setSelectedUsers(value || []); // Set the matched users or an empty array
      // setSelectedUserIds(value?.map((user) => user?.id) || []); // Extract their IDs or set to an empty array
    }
  }, [selectedChat, groupMemberDetail]);

  const selectedSingleUser=(user)=>{
    setRoomId(user?.[0]?.id)
  }

  return (
    <>
      <Modal
         isOpen={isGroupModalOpen?.open|| newChatDisc.isOpen}
        onClose={() => {
          setIsGroupModalOpen({ open: false, data: '' });
          setIsCreateGroupedClicked(false);
          newChatDisc.onClose();
        }}
        height={'120px'}
      >
        {/* <ModalOverlay /> */}
        <ModalContent marginTop="150px">
          {/* <ModalCloseButton /> */}
          <ModalHeader>
            <HStack justifyContent="space-between">
              <Text
                fontFamily="Inter"
                fontSize="15px"
                fontWeight={600}
                lineHeight="18px"
                textAlign="left"
                textUnderlinePosition="from-font"
                textDecorationSkipInk="none"
                color="#5B5B5B"
              >
                {' '}
                {t('myMessages.newMessage') || "New Message"}
              </Text>
              <Button
                width={["70px","57px"]}
                height={["35","28px"]}
                padding="9px 18px 9px 18px"
                gap="10px"
                borderRadius="76px"
                isDisabled={createGroupLoading || !selectedUsers?.length}
                bgColor={'#3D5A80'}
                disabled={createGroupLoading || !selectedUsers?.length }
                fontFamily="Inter"
                fontSize="12px"
                fontWeight={500}
                lineHeight="14.4px"
                border="transparent"
                color="#ffffff"
                onClick={() => {
                  // if (selectedUsers?.length === 1) {
                  //   selectedSingleUser(selectedUsers)
                  // } else {
                    if (isGroupModalOpen?.data !== 'create') {
                      setGroupName('');
                      handleCreateGroup();
                    } else {
                      handleCreateGroup();
                    }
                }}
                  
              >
                {createGroupLoading?<Spinner size="xs"/>:t('buttons.next') || "Next"}
              </Button>
            </HStack>
          </ModalHeader>
          <ModalBody>
            <HStack gap="10px" borderBottom="1px solid #E4E6EB" mb={3}>
              <SearchIcon w="18px" h="18px" />
              <Input
                placeholder={t('myMessages.searchPeople') || "Search people"}
                value={searchTerm}
                onChange={(e) => {
                  const val = e.target.value;
                  setSearchTerm(val?.charAt(0).toUpperCase() + val?.slice(1));
                }}
                borderRadius="0px"
                border="unset"
                _focus={{
                  border: 'unset',
                }}
                backgroundColor="transparent"
              />
            </HStack>

            {/* Create a Group */}
            <HStack spacing={2} mb={4} cursor="pointer">

              {isCreateGroupedClicked&&(<Box onClick={()=>setIsCreateGroupedClicked(false)}>
            {direction === 'rtl' ? <BackArrowRTL /> : <BackArrow/>}

              </Box>)}
              <Avatar icon={<MyNetworkNewIcon width="16px" height="16px" />} />
              <Text
                fontFamily="Inter"
                fontSize="14px"
                fontWeight={500}
                lineHeight="16.8px"
                color="#3D5A80"
                onClick={() => {
                  setIsCreateGroupedClicked(true);
                  setSelectedUsers([]);
                }}
              >
               
                {t('myMessages.createGroup') || "Create a group"}
              </Text>
            </HStack>
            {isCreateGroupedClicked&&(
             <VStack mt={6} alignItems={"start"} gap="10px">
             {/* <SearchIcon w="18px" h="18px" /> */}
             <Text
                fontFamily="Inter"
                fontSize="14px"
                fontWeight={500}
                lineHeight="16.8px"
                color="#3D5A80"
                // onClick={() => {
                //   setIsCreateGroupedClicked(true);
                //   setSelectedUsers([]);
                // }}
              >
               
               {t('myMessages.groupNameOptional') || "Group Name (Optional)"}
              </Text>
             <Input
               placeholder={t('myMessages.groupName') || "Group Name"}
               value={groupNameOptional}
               onChange={(e) => setGroupNameOptional(e.target.value)}
               borderRadius="10px"
               borderColor="#DFDFDF"
               _focus={{
                border:"unset",
              }}
              //  backgroundColor="transparent"
             />
             <Text></Text>
           </VStack>
            )}
            {/* Suggested Users */}
            {isCreateGroupedClicked && (
              <Text fontSize="sm" color="gray.500" mb={2}>
                {t('myMessages.suggested') || "Suggested"}
              </Text>
            )}

            {!isCreateGroupedClicked ? (
              // Only show search results when searching in normal mode
              searchTerm ? (
                <VStack
                  align="stretch"
                  spacing={4}
                  overflow={'auto'}
                  sx={{
                    '&::-webkit-scrollbar': {
                      width: '5px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                      background: '#C8C8C8',
                      borderRadius: '51px',
                    },
                    '&::-webkit-scrollbar-thumb:hover': {
                      background: '#555',
                    },
                    '&::-webkit-scrollbar-track': {
                      background: '#EDEDED',
                    },
                  }}
                  height="45vh"
                >
                  {filteredConnectionList?.map((user) => (
                    <HStack
                      key={user?.matrix_user_id}
                      onClick={() => {
                        const matchedUser = connectionList?.find(
                          (connection) =>
                            connection?.user_details?.user_id ===
                            user?.matrix_user_id
                        );

                        if (matchedUser) {
                          onSelectChat(matchedUser);
                          setRoomId(matchedUser?.room_id);
                          setIsGroupModalOpen({ open: false, data: '' });
                          newChatDisc.onClose();
                        } else {
                          onSelectChat(user); // Fallback to the current user in case no match is found
                          setRoomId(user?.room_id);
                          setIsGroupModalOpen({ open: false, data: '' });
                          newChatDisc.onClose();
                        }
                      }}
                      justifyContent="space-between"
                      cursor="pointer"
                    >
                      <HStack spacing={3}>
                        <Avatar
                          src={user?.profile_pic}
                          name={`${user?.first_name || ''} ${
                            user?.last_name || ''
                          }`.trim()}
                        />
                        <Box>
                          <Text fontWeight="bold" fontSize="sm">
                            {`${user?.first_name || ''} ${
                              user?.last_name || ''
                            }`.trim()}
                          </Text>
                          <Text fontSize="xs" color="gray.500">
                            {/* {user.title} */}
                          </Text>
                        </Box>
                      </HStack>
                    </HStack>
                  ))}
                </VStack>
              ) : null
            ) : (
              // Show selected users and search results in create group mode
              <VStack
                align="stretch"
                spacing={4}
                overflow={'auto'}
                sx={{
                  '&::-webkit-scrollbar': {
                    width: '5px',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    background: '#C8C8C8',
                    borderRadius: '51px',
                  },
                  '&::-webkit-scrollbar-thumb:hover': {
                    background: '#555',
                  },
                  '&::-webkit-scrollbar-track': {
                    background: '#EDEDED',
                  },
                }}
                height="45vh"
              >
                <Box display="flex" flexWrap="wrap" gap="10px">
                  {selectedUsers?.map((user, index) => (
                    <HStack
                      key={user?.room_id || index}
                      gap={'5px'}
                      border="1px solid #D9D9D9"
                      borderRadius="17px"
                      width="-webkit-max-content"
                      padding={'5px 7px'}
                      margin={'5px 0'}
                      alignItems={'center'}
                    >
                      <Avatar
                        width="23px"
                        height="23px"
                        src={user?.profile_pic}
                        name={`${user?.first_name || ''}`.trim()}
                      />

                      <Text fontWeight="bold" fontSize="sm">
                        {`${user?.first_name || ''} ${
                          user?.last_name || ''
                        }`.trim()}
                      </Text>

                      <CloseIcon
                        width="8px"
                        height="8px"
                        cursor="pointer"
                        onClick={() =>
                          handleRemoveSelectedUser(user?.id)
                        }
                      />
                    </HStack>
                  ))}
                </Box>
                {filteredConnectionList?.map((user) => (
                  <HStack
                    // key={user?.room_id}
                    key={user?.id || user?.room_id}
                    onClick={() => handleCheckboxChange(user)}
                    justifyContent="space-between"
                    cursor="pointer"
                    pr={2}
                  >
                    <HStack spacing={3}>
                      <Avatar
                        src={user?.profile_pic}
                        name={`${user?.first_name || ''} ${
                          user?.last_name || ''
                        }`.trim()}
                      />
                      <Box>
                        <Text fontWeight="bold" fontSize="sm">
                          {`${user?.first_name || ''} ${
                            user?.last_name || ''
                          }`.trim()}
                        </Text>
                        <Text fontSize="xs" color="gray.500">
                          {/* {user.title} */}
                        </Text>
                      </Box>
                    </HStack>
                    <Checkbox
                      isChecked={selectedUsers?.some(
                        (selectedUser) =>
                          selectedUser?.id === user?.id
                      )}
                      // onChange={() => handleCheckboxChange(user)}
                      pointerEvents="none"
                      borderRadius="full"
                      sx={{
                        '& span': {
                          borderRadius: '50%',
                          border: '1.5px solid #868585',
                          width: '18px',
                          height: '18px',
                        },
                        '& span[data-checked]': {
                          bg: '#3D5A80',
                          border: '1.5px solid #868585',
                        },
                        '& span[data-focus-visible]': {
                          boxShadow: 'unset',
                        },
                      }}
                    />
                  </HStack>
                ))}
              </VStack>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
      <ChangeGroupName
        onClose={() => setIsgroupNameModal({ open: false, data: '' })}
        isModal={isgroupNameModal}
        setGroupName={setGroupName}
        groupName={groupName}
        handleUpdateGroupName={handleUpdateGroupName}
      />
    </>
  );
};

export default ChatGroup;
